import { MapStackLayer } from '../components/MapView/MapStackLayer'

export const stackIds = {
  satellitePlaces: 'satellite-places-stack',
  satellite: 'satellite-stack',
  roadMap: 'road-map-stack',
  ENRCL: 'ENRCL-stack',
  ENRCH: 'ENRCH-stack',
  WAC: 'WAC-stack',
  ARC: 'ARC-stack',
  REA: 'REA-stack',
  REH: 'REH-stack',
  REUL: 'REUL-stack',

  // User Charts (raster do usuário, acima do mapa base)
  userCharts: 'user-charts-stack',

  // Airspaces
  airspaces: {
    adiz: 'airspace-adiz-stack',
    afis: 'airspace-afis-stack',
    atz: 'airspace-atz-stack',
    ctr: 'airspace-ctr-stack',
    freeRouteAreas: 'airspace-freeRouteAreas-stack',
    fis: 'airspace-fis-stack',
    fir: 'airspace-fir-stack',
    firSector: 'airspace-firSector-stack',
    fiz: 'airspace-fiz-stack',
    fca: 'airspace-fcaRea-stack',
    fcaReh: 'airspace-fcaReh-stack',
    fcaAd: 'airspace-fcaAd-stack',
    suaDangerous: 'airspace-suaDangerous-stack',
    suaProhibited: 'airspace-suaProhibited-stack',
    suaRestricted: 'airspace-suaRestricted-stack',
    tma: 'airspace-tma-stack',
    tmaSector: 'airspace-tmaSector-stack',
    cta: 'airspace-cta-stack',
    ctaSector: 'airspace-ctaSector-stack',
    // Âncora genérica para tipos de airspace não catalogados (chaves cruas do dataset).
    extras: 'airspace-extras-stack'
  },

  // Airspaces Labels
  airspacesLabel: {
    adiz: 'airspace-adiz-label-stack',
    afis: 'airspace-afis-label-stack',
    atz: 'airspace-atz-label-stack',
    ctr: 'airspace-ctr-label-stack',
    freeRouteAreas: 'airspace-freeRouteAreas-label-stack',
    fis: 'airspace-fis-label-stack',
    fir: 'airspace-fir-label-stack',
    firSector: 'airspace-firSector-label-stack',
    fiz: 'airspace-fiz-label-stack',
    fca: 'airspace-fcaRea-label-stack',
    fcaReh: 'airspace-fcaReh-label-stack',
    fcaAd: 'airspace-fcaAd-label-stack',
    suaDangerous: 'airspace-suaDangerous-label-stack',
    suaProhibited: 'airspace-suaProhibited-label-stack',
    suaRestricted: 'airspace-suaRestricted-label-stack',
    tma: 'airspace-tma-label-stack',
    tmaSector: 'airspace-tmaSector-label-stack',
    cta: 'airspace-cta-label-stack',
    ctaSector: 'airspace-ctaSector-label-stack',
    extras: 'airspace-extras-label-stack'
  },
  // Notams
  notams: 'notams-stack',
  notamsLabel: 'notams-label-stack',
  // Measuring Segment
  measuringSegment: 'measuring-segment-stack',
  // Meteorology
  meteorology: 'meteorology-stack',
  // Fuel
  fuel: 'fuel-stack',
  // Obstacles
  obstacles: 'obstacles-stack',
  // User Geometries (KML/KMZ)
  userGeometries: {
    polygon: 'user-geometries-polygon-stack',
    line: 'user-geometries-line-stack',
    point: 'user-geometries-point-stack',
    polygonLabel: 'user-geometries-polygon-label-stack',
    pointLabel: 'user-geometries-point-label-stack'
  },
  // Navaids
  navaids: 'navaids-stack',
  // Route
  route: {
    pointLabel: 'route-point-label-stack',
    point: 'route-point-stack',
    lineLabel: 'route-line-label-stack',
    line: 'route-line-stack',
    TocAndTod: 'route-toc-and-tod-stack'
  },
  // MapADHP
  adhp: 'adhp-stack',
  trackHeadboard: 'track-headboard-stack',
  // Procedure Chart
  procedureChart: 'procedure-chart-stack',
  procedureChartButtons: 'procedure-chart-buttons-stack',
  mapTarget: 'map-target-stack'
}

function MapStackPresenter() {
  return (
    <>
      <MapStackLayer id={stackIds.satellitePlaces} />
      <MapStackLayer id={stackIds.satellite} />
      <MapStackLayer id={stackIds.roadMap} />
      <MapStackLayer id={stackIds.ENRCL} />
      <MapStackLayer id={stackIds.ENRCH} />
      <MapStackLayer id={stackIds.WAC} />
      <MapStackLayer id={stackIds.ARC} />
      <MapStackLayer id={stackIds.REA} />
      <MapStackLayer id={stackIds.REH} />
      <MapStackLayer id={stackIds.REUL} />

      {/* Base Charts */}

      {/* User Charts */}
      <MapStackLayer id={stackIds.userCharts} />

      {/* Procedure Chart */}
      <MapStackLayer id={stackIds.procedureChart} />

      {/* Airspaces */}
      <MapStackLayer id={stackIds.airspaces.adiz} />
      <MapStackLayer id={stackIds.airspaces.afis} />
      <MapStackLayer id={stackIds.airspaces.atz} />
      <MapStackLayer id={stackIds.airspaces.ctr} />
      <MapStackLayer id={stackIds.airspaces.freeRouteAreas} />
      <MapStackLayer id={stackIds.airspaces.fis} />
      <MapStackLayer id={stackIds.airspaces.fir} />
      <MapStackLayer id={stackIds.airspaces.firSector} />
      <MapStackLayer id={stackIds.airspaces.fiz} />
      <MapStackLayer id={stackIds.airspaces.fca} />
      <MapStackLayer id={stackIds.airspaces.fcaReh} />
      <MapStackLayer id={stackIds.airspaces.fcaAd} />
      <MapStackLayer id={stackIds.airspaces.suaDangerous} />
      <MapStackLayer id={stackIds.airspaces.suaProhibited} />
      <MapStackLayer id={stackIds.airspaces.suaRestricted} />
      <MapStackLayer id={stackIds.airspaces.tma} />
      <MapStackLayer id={stackIds.airspaces.tmaSector} />
      <MapStackLayer id={stackIds.airspaces.cta} />
      <MapStackLayer id={stackIds.airspaces.ctaSector} />
      <MapStackLayer id={stackIds.airspaces.extras} />

      {/* Airspaces Labels */}
      <MapStackLayer id={stackIds.airspacesLabel.adiz} />
      <MapStackLayer id={stackIds.airspacesLabel.afis} />
      <MapStackLayer id={stackIds.airspacesLabel.atz} />
      <MapStackLayer id={stackIds.airspacesLabel.ctr} />
      <MapStackLayer id={stackIds.airspacesLabel.freeRouteAreas} />
      <MapStackLayer id={stackIds.airspacesLabel.fis} />
      <MapStackLayer id={stackIds.airspacesLabel.fir} />
      <MapStackLayer id={stackIds.airspacesLabel.firSector} />
      <MapStackLayer id={stackIds.airspacesLabel.fiz} />
      <MapStackLayer id={stackIds.airspacesLabel.fca} />
      <MapStackLayer id={stackIds.airspacesLabel.fcaReh} />
      <MapStackLayer id={stackIds.airspacesLabel.fcaAd} />
      <MapStackLayer id={stackIds.airspacesLabel.suaDangerous} />
      <MapStackLayer id={stackIds.airspacesLabel.suaProhibited} />
      <MapStackLayer id={stackIds.airspacesLabel.suaRestricted} />
      <MapStackLayer id={stackIds.airspacesLabel.tma} />
      <MapStackLayer id={stackIds.airspacesLabel.tmaSector} />
      <MapStackLayer id={stackIds.airspacesLabel.cta} />
      <MapStackLayer id={stackIds.airspacesLabel.ctaSector} />
      <MapStackLayer id={stackIds.airspacesLabel.extras} />

      {/* Notams */}
      <MapStackLayer id={stackIds.notams} />
      <MapStackLayer id={stackIds.notamsLabel} />
      {/* Meteorology */}
      <MapStackLayer id={stackIds.meteorology} />
      {/* Fuel */}
      <MapStackLayer id={stackIds.fuel} />
      {/* Obstacles */}
      <MapStackLayer id={stackIds.obstacles} />
      {/* User Geometries (KML/KMZ) */}
      <MapStackLayer id={stackIds.userGeometries.polygon} />
      <MapStackLayer id={stackIds.userGeometries.line} />
      <MapStackLayer id={stackIds.userGeometries.point} />
      <MapStackLayer id={stackIds.userGeometries.polygonLabel} />
      <MapStackLayer id={stackIds.userGeometries.pointLabel} />
      {/* Navaids */}
      <MapStackLayer id={stackIds.navaids} />
      {/* MapADHP */}
      <MapStackLayer id={stackIds.adhp} />
      {/* Route */}
      <MapStackLayer id={stackIds.route.line} />
      <MapStackLayer id={stackIds.route.lineLabel} />
      <MapStackLayer id={stackIds.route.TocAndTod} />
      <MapStackLayer id={stackIds.route.point} />
      <MapStackLayer id={stackIds.route.pointLabel} />
      {/* TrackHeadboard */}
      <MapStackLayer id={stackIds.trackHeadboard} />
      {/* Procedure Chart */}
      <MapStackLayer id={stackIds.procedureChartButtons} />
      {/* Measuring Segment */}
      <MapStackLayer id={stackIds.measuringSegment} />
      {/* Map Target */}
      <MapStackLayer id={stackIds.mapTarget} />
    </>
  )
}

// Resolve a âncora de z-order de um tipo de airspace: tipos conhecidos usam a sua
// âncora nomeada; desconhecidos (cruas do dataset) caem na âncora genérica `extras`.
export const getAirspaceStackId = (type: string): string =>
  (stackIds.airspaces as Record<string, string>)[type] ?? stackIds.airspaces.extras

export const getAirspaceLabelStackId = (type: string): string =>
  (stackIds.airspacesLabel as Record<string, string>)[type] ?? stackIds.airspacesLabel.extras

export { MapStackPresenter }
